import { TLang } from 'src/constants/langs'

import WheelDataEn from 'src/icons/wheel-data-en.webp'
import WheelDataDe from 'src/icons/wheel-data-de.webp'
import WheelDataRo from 'src/icons/wheel-data-ro.webp'
import WheelDataEs from 'src/icons/wheel-data-es.webp'
import WheelDataFr from 'src/icons/wheel-data-fr.webp'
import WheelDataIt from 'src/icons/wheel-data-it.webp'
import WheelDataPt from 'src/icons/wheel-data-pt.webp'
import WheelDataEl from 'src/icons/wheel-data-el.webp'
import WheelDataSl from 'src/icons/wheel-data-sl.webp'

interface ITextBtn {
    lang: TLang
    text: string
}

export const textBtn: ITextBtn[] = [
    {
        lang: 'ro',
        text: 'А ÎNVÂRTI',
    },
    {
        lang: 'de',
        text: 'DREH',
    },
    {
        lang: 'es',
        text: 'Giro',
    },
    {
        lang: 'en',
        text: 'SPIN',
    },
    {
        lang: 'fr',
        text: 'TOUR',
    },
    {
        lang: 'it',
        text: 'GIRO',
    },
    {
        lang: 'pt',
        text: 'GIRO',
    },
    {
        lang: 'el',
        text: 'Περιστροφή',
    },
    {
        lang: 'sl',
        text: 'ZAVRTI',
    },
]

export const imageWheelDataMap: Record<TLang, string> = {
    ro: WheelDataRo,
    de: WheelDataDe,
    es: WheelDataEs,
    en: WheelDataEn,
    fr: WheelDataFr,
    it: WheelDataIt,
    pt: WheelDataPt,
    el: WheelDataEl,
    sl: WheelDataSl,
}
